import { makeStyles } from '@material-ui/core/styles';
const fill = {
    display: 'inline-block',
    height: '100%',
    paddingLeft: '0',
    paddingRight: '0',
    width: '100%',
};

export default makeStyles(theme => ({
    button: {
        color: theme.palette.common.white,
    },
    cardImage: {
        bottom: 0,
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
    },
    customBackground: props => ({
        '& .rst__rowTitle, & .rst__rowContents': {
            backgroundColor: 'transparent',
        },
        color: theme.palette.common.white,
        backgroundImage: props.customCardBackground ? `url(${props.customCardBackground})` : 'none',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
    }),
    icon: {
        color: theme.palette.common.white,
        position: 'absolute',
        right: 15,
        top: 0,
        zIndex: 1,
    },
    name: {
        paddingLeft: '5px',
        zIndex: 1,
    },
    node: {
        '& .rst__moveHandle': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
        },
        '& .rst__rowContents': {
            paddingLeft: '0',
            paddingRight: '0',
        },
        '& .rst__rowLabel': {
            extend: fill,
        },
        '& .rst__rowTitle': {
            '& :hover': {
                cursor: 'pointer',
            },
            '& > div': {
                alignItems: 'center',
                display: 'flex',
                extend: fill,
            },
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            extend: fill,
        },
        alignItems: 'center',
        border: '5px solid white',
        display: 'flex',
        overflow: 'hidden',
        position: 'relative',
    },
    remove: {
        '&:hover': {
            cursor: 'pointer',
        },
        bottom: 0,
        color: theme.palette.common.white,
        extend: 'icon',
        right: 0,
        top: 'auto',
    },
    topLevelBackground: props => ({
        '& .rst__rowTitle': {
            //When image is present, let's change background color and font color
            backgroundColor: props.backgroundImage ? 'transparent' : theme.palette.common.black,
            //We want image to be visible
            color: theme.palette.common.white,
        },
        backgroundImage: props.commonBackground ? `url(${props.commonBackground})` : 'none',
    }),
    topLevelNode: {
        '& .rst__rowContents': {
            backgroundColor: 'transparent',
        },
        '& .rst__rowWrapper': {
            padding: '5px',
            '&:hover': {
                cursor: 'pointer',
            },
        },
        '& $TitleContent': {
            backgroundColor: 'yellow!important',
        },
        backgroundSize: 'auto',
        height: '100px',
    },
    tree: () => ({
        backgroundColor: 'green',
        position: 'relative',
    }),
    TreeControls: {
        paddingLeft: theme.spacing(5),
        position: 'relative',
        textAlign: 'left',
    },
    wrapper: {
        '& .rst__lineBlock:after, .rst__lineBlock:before, .rst__lineChildren:after': {
            border: '2px solid black',
            borderColor: theme.palette.primary.main,
        },
        '& .rst__rowLandingPad': {
            backgroundColor: theme.palette.secondary.main,
            border: '3px dotted white!important',
        },
        '& .rst__tree': {
            marginTop: theme.spacing(3),
        },
        '& .rst__row.active': {
            border: `3px solid ${theme.palette.secondary.light}!important`,
        },
    },
}));
